import React from "react";
import { authRoles } from "../../utils/auth/authRoles";

const contactRoutes = [
  {
    path: "/my-team/team-lead",
    component: React.lazy(() => import("./TeamLeads")),
    auth: authRoles.level3
  },
  {
    path: "/my-team/assign-open-lead",
    component: React.lazy(() => import("./OpenLeads")),
    auth: authRoles.level3
  }
];

export default contactRoutes;
